export default "__VITE_ASSET__ea91c129__"